import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './appTitle.scss';
import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, px } from '../util/utils';

/** Block */
const blockBaseClassName = 'appTitle';

/** Element */
const textClassName = 'appTitle__text';
const imageClassName = 'appTitle__image';

/** A component for displaying your application title and logo */
export class AppTitle extends Component {
  static propTypes = {
    /** @ignore */
    children: renderableType,
    /** @ignore */
    className: PropTypes.string,
    /** @ignore */
    isAppTitle: PropTypes.bool,
    /** Component to be rendered as the app title */
    component: renderableType,
    /** The alt text applied to the image */
    imageAlt: PropTypes.string,
    /** The height and width of the image */
    imageDimensions: PropTypes.shape({
      height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    /** The path to the image */
    imageSrc: PropTypes.string,
    /** Function executed on click */
    onClick: PropTypes.func,
    /** The tooltip displayed on hover of the title text */
    title: PropTypes.string,
  };
  static defaultProps = {
    isAppTitle: true,
    imageDimensions: {
      height: 'auto',
      width: '1.5rem',
    },
  };

  handleKeyDown = (e) => {
    if (this.props.onClick) {
      if (e.key === 'Enter') {
        e.stopPropagation();
        const savedEvent = e;
        this.props.onClick(savedEvent);
      }
    }
  };

  render() {
    const {
      children,
      className,
      isAppTitle,
      component,
      imageAlt,
      imageDimensions: { height, width },
      imageSrc,
      onClick,
      title,
      ...other
    } = this.props;
    const CompType = component || 'a';
    const blockClassNames = buildClassNames(className, blockBaseClassName);
    const image = imageSrc && (
      <img
        style={{
          height: px(height),
          width: px(width),
        }}
        alt={imageAlt}
        src={imageSrc}
        className={imageClassName}
      />
    );
    return (
      <CompType role='link' tabIndex={0} className={blockClassNames} onClick={onClick} onKeyDown={this.handleKeyDown} {...other}>
        {image}
        {children && <div className={textClassName} title={title}>{children}</div>}
      </CompType>
    );
  }
}
